// Mock data and translations for Lokam Health
// WhatsApp business number - replace with real one later
export const WHATSAPP_NUMBER = "918299548152";
export const WHATSAPP_DISPLAY = "+91 82995 48152";
export const SUPPORT_EMAIL = "support@lokamhealth.com";
export const WHATSAPP_DEFAULT_MSG = "Hi%20Lokam!%20I%20want%20to%20order%20my%20medicines.";
export const waLink = (msg = WHATSAPP_DEFAULT_MSG) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;

export const translations = {
  en: {
    code: "en",
    label: "English",
    short: "EN",
    offer: "Flat 25% off on your 1st order",
    hospitals_link: "For Hospitals",
    nav: {
      how: "How it works",
      coverage: "Coverage",
      support: "Support",
      cta: "Order on WhatsApp",
    },
    hero: {
      eyebrow: "India's first conversational pharmacy",
      title_part1: "Order medicines like you talk to your",
      title_highlight: "local chemist.",
      subtitle:
        "Send a photo of a prescription. A partial name. Even a voice note saying 'send my regular baby drops'. We figure it out — and deliver in 60 minutes.",
      cta_primary: "Start on WhatsApp",
      cta_secondary: "See how it works",
      trust: "No app needed · Pay on delivery · 60 Min Express Delivery",
    },
    chat: {
      bubble1: "Bhaiya, monthly BP medicines bhej do 🙏",
      bubble2: "Aur ye prescription bhi dekho 📎",
      bubble3: "Your total order value is ₹485. We can deliver in 60 mins. Do you want to confirm?",
      bubble4: "Haan confirm, thanks!",
      stamp_left: "You · just now",
      stamp_right: "Lokam · auto-confirmed",
      delivery: "Out for delivery · 52 min",
    },
    chaos: {
      title: "However you'd say it to your chemist —",
      subtitle: "We get it. No menus. No forms. No medicine search to look up.",
      items: [
        { icon: "image", title: "A blurry prescription photo", note: "Even the doctor's handwriting" },
        { icon: "mic", title: "\"Send my regular baby drops\"", note: "We remember your usuals" },
        { icon: "type", title: "Half a medicine name", note: "\"Wo cholesterol wali\"" },
        { icon: "camera", title: "Photo of an old strip", note: "Snap it. Send it. Done." },
        { icon: "repeat", title: "\"Monthly BP medicines\"", note: "Refill in two taps" },
        { icon: "globe", title: "English, Kannada or Hindi", note: "Talk to us like your smart local chemist" },
      ],
    },
    catalog: {
      eyebrow: "Catalogue & launch offer",
      offer_kicker: "Fix discount",
      offer_title: "Flat 20% discount on all your purchases.",
      offer_body: "Stock up on your monthly refills, vitamins, or anything you usually run to the chemist for — and save 25% on your very first order. No code needed; we apply it on your first WhatsApp chat.",
      offer_cta: "Claim on WhatsApp",
      catalog_kicker: "We stock up",
      catalog_title: "30,000+ medicines & healthcare products",
      catalog_body: "From everyday chronic-condition medicines like Hypertension, Diabetes and Thyroid, all the way to specialty pharma — vaccines, injections and higher antibiotics. If your chemist stocks it, we can get it to your door.",
      cats: [
        { title: "Hypertension", note: "BP tablets, monitors, refill reminders" },
        { title: "Diabetes", note: "Anti-diabetics, glucometers, strips, insulin" },
        { title: "Thyroid", note: "Thyroxine + thyroid-friendly supplements" },
        { title: "Vaccines", note: "Adult & pediatric, cold-chain handled" },
        { title: "Injections", note: "Prescription injectables, sterile delivery" },
        { title: "Higher antibiotics", note: "Specialty antibiotics on Rx, sourced fast" },
      ],
    },
    generics: {
      eyebrow: "Smart choice",
      title: "Same salt. Smarter price.",
      subtitle: "Every medicine is a chemical composition, not a brand. Doctors treat patients through composition but prescribe a brand that is promoted to them. Our qualified pharmacists can offer you a doctor-recommended branded generic from top Indian pharma — same salt, same strength, up to 60% cheaper. Your call, every time.",
      brand: {
        kicker: "Prescribed brand",
        name: "Telma 40",
        maker: "Glenmark",
        price: "₹156",
        unit: "per strip",
        bullet: "Exactly as prescribed",
        action: "Keep brand",
      },
      generic: {
        kicker: "Branded generic",
        name: "Telmisartan 40 mg",
        maker: "Cipla · Sun · Dr. Reddy's",
        price: "₹62",
        unit: "per strip",
        savings: "SAVE 60%",
        bullets: ["Same salt · same strength", "Doctor-approved", "Top Indian pharma"],
        action: "Switch & save",
      },
      divider: "OR — your choice",
      chips: [
        "Only doctor-recommended generics",
        "100% same molecule, same mg",
        "Save up to 60%",
      ],
      cta: "Ask about generics on WhatsApp",
    },
    how: {
      eyebrow: "How it works",
      title: "Four steps. One WhatsApp chat.",
      steps: [
        { n: "01", title: "Say it your way", body: "Text, voice note, or photo on WhatsApp. Mix languages. It's all good." },
        { n: "02", title: "We decode & confirm", body: "Our qualified Pharmacists figure out what you need and confirm price + ETA in seconds." },
        { n: "03", title: "Trusted local store packs", body: "Your nearest Lokam Pharmacy verifies and packs the order." },
        { n: "04", title: "60-minute delivery", body: "Doorstep delivery starts in 60 minutes. Pay online or cash on delivery." },
      ],
    },
    coverage: {
      eyebrow: "Service coverage",
      title: "Live in select areas in Bangalore. Expanding across Bangalore very soon.",
      subtitle: "We're starting hyperlocal — neighbourhood by neighbourhood. Don't see your area? Drop us a message and we'll prioritise it.",
      now: "Available now",
      soon: "Launching soon",
      areas_now: [
        "HSR Layout", "Bellandur", "Sarjapur Road", "Harlur",
        "Choodasandra", "Bommanahalli", "Banashankari", "Nagarbhavi",
        "Jayanagar", "JP Nagar", "Vijayanagar", "Kanakpura Road", "Basavanagudi",
      ],
      areas_soon: [
        "Whitefield", "Indiranagar", "Koramangala", "Hebbal", "Yelahanka", "Marathahalli",
      ],
    },
    trust: {
      eyebrow: "Why families trust us",
      title: "Built for the way India actually orders medicine.",
      points: [
        { title: "Trusted local pharmacies in your area", body: "Every partner is a licensed pharmacy in your neighbourhood. No grey-market sourcing." },
        { title: "Competitive prices", body: "Better than most online pharmacies, with discounts on your regular monthly orders." },
        { title: "Real humans on standby", body: "Our pharmacy assistants step in whenever the order is unclear. No dead-ends." },
        { title: "Refills remembered", body: "We track your monthly medicines, so a single 'usual please' is enough." },
      ],
    },
    hospitals: {
      eyebrow: "For hospitals & nursing homes",
      title: "Grow your pharmacy margins with branded generics.",
      subtitle: "Source 1,000+ molecules across every therapeutic category at India's most competitive rates — from WHO-GMP, ISO-certified, FDA-approved manufacturing units. Every batch ships with a testing report.",
      benefits: [
        { icon: "truck", title: "Hassle-free ordering", body: "Seamless online ordering with live support from the backend team on call." },
        { icon: "clock", title: "Same-day deliveries", body: "Your IV fluids and antibiotics stocked before the next shift begins." },
        { icon: "layers", title: "Longest therapeutic range", body: "10+ therapeutic categories, 1,000+ molecules, growing every week." },
        { icon: "stethoscope", title: "Critical-care specialists", body: "Depth in injectables, higher antibiotics, IV fluids and the full ICU formulary." },
      ],
      trust_strip_title: "Trust",
      trust_badges: [
        "WHO-GMP",
        "ISO-certified",
        "FDA-approved",
        "Batch testing report with every delivery",
      ],
      categories_title: "A snapshot of what we stock",
      categories_subtitle: "A sample across the depth of our therapeutic range — many more molecules in stock, with new additions every week.",
      categories_legend: { molecules: "Molecules", brands: "Brands", skus: "SKUs" },
      categories: [
        { icon: "pill", name: "Antibiotics & anti-infectives", molecules: 69, brands: 128, skus: 66 },
        { icon: "heart-pulse", name: "Critical care & ICU", molecules: 17, brands: 29, skus: 28 },
        { icon: "stomach", name: "Gastro & liver", molecules: 42, brands: 63, skus: 11 },
        { icon: "bone", name: "Pain, inflammation & musculoskeletal", molecules: 36, brands: 51, skus: 10 },
        { icon: "shield-plus", name: "Steroids, hormones & women's health", molecules: 13, brands: 25, skus: 17 },
        { icon: "brain", name: "Neuro", molecules: 9, brands: 14, skus: 10 },
        { icon: "wind", name: "Respiratory & allergy", molecules: 16, brands: 23 },
        { icon: "sparkles", name: "Vitamins, minerals & nutrition", molecules: 43, brands: 70, skus: 23 },
      ],
      cta_primary: "Talk to our B2B team on WhatsApp",
      cta_secondary: "Request a price list",
      cta_primary_msg: "Hi%20Lokam%2C%20I%20run%20a%20hospital%2Fnursing%20home%2Fpharmacy%20and%20want%20to%20discuss%20B2B%20supply%20of%20branded%20generics.",
      cta_secondary_msg: "Hi%20Lokam%2C%20please%20share%20your%20B2B%20price%20list%20for%20branded%20generics.",
    },
    support: {
      eyebrow: "Support",
      title: "Talk to a human. Any time.",
      subtitle: "Questions, refills, refunds, or just need help reading a prescription? Reach us the way you prefer.",
      whatsapp: "Chat on WhatsApp",
      call: "Call us",
      email: "Email us",
      hours: "7 AM – 11 PM · Every day",
    },
    footer: {
      tagline: "India's first conversational healthcare delivery platform. Order like you'd talk.",
      links_company: "Company",
      links_legal: "Policies",
      company: ["Press"],
      legal: [
        { label: "Privacy Policy", to: "/privacy" },
        { label: "Terms of Service", to: "/terms" },
        { label: "Cancellation & Refund", to: "/refund-policy" },
      ],
      rights: "© 2025 Billion Health Technologies Pvt. Ltd. All rights reserved.",
    },
    floating: {
      label: "Order on WhatsApp",
    },
  },
  hi: {
    code: "hi",
    label: "हिन्दी",
    short: "हि",
    offer: "आपके पहले ऑर्डर पर FLAT 25% OFF",
    hospitals_link: "अस्पतालों के लिए",
    nav: {
      how: "कैसे काम करता है",
      coverage: "सेवा क्षेत्र",
      support: "सहायता",
      cta: "WhatsApp पर ऑर्डर करें",
    },
    hero: {
      eyebrow: "भारत की पहली बातचीत वाली फार्मेसी",
      title_part1: "अपने केमिस्ट से जैसे बात करते हैं, वैसे ही",
      title_highlight: "दवा मँगाइए।",
      subtitle:
        "प्रिस्क्रिप्शन की फोटो भेजिए। आधा नाम लिखिए। या बोलकर कहिए 'मेरी रोज़ की baby drops भेज दो'। हम समझ जाएँगे — और 60 मिनट में डिलीवर कर देंगे।",
      cta_primary: "WhatsApp पर शुरू करें",
      cta_secondary: "देखिए कैसे काम करता है",
      trust: "ऐप की ज़रूरत नहीं · डिलीवरी पर भुगतान · 60 मिनट एक्सप्रेस डिलीवरी",
    },
    chat: {
      bubble1: "भैया, महीने वाली BP की दवा भेज दो 🙏",
      bubble2: "और ये प्रिस्क्रिप्शन भी देख लो 📎",
      bubble3: "आपके ऑर्डर का कुल मूल्य ₹485 है। हम 60 मिनट में डिलीवर कर सकते हैं। क्या आप कन्फर्म करना चाहेंगे?",
      bubble4: "हाँ कन्फर्म, धन्यवाद!",
      stamp_left: "आप · अभी",
      stamp_right: "Lokam · ऑटो-कन्फर्म",
      delivery: "डिलीवरी के लिए निकल चुकी · 52 मिनट",
    },
    chaos: {
      title: "जैसे आप अपने केमिस्ट से कहते हैं —",
      subtitle: "हम भी वैसे ही समझते हैं। न मेन्यू, न फॉर्म, न कोड।",
      items: [
        { icon: "image", title: "धुँधली प्रिस्क्रिप्शन फोटो", note: "डॉक्टर की handwriting भी" },
        { icon: "mic", title: "\"मेरी रोज़ की baby drops भेज दो\"", note: "हम याद रखते हैं" },
        { icon: "type", title: "आधा नाम भी काफ़ी है", note: "\"वो cholesterol वाली\"" },
        { icon: "camera", title: "पुरानी पत्ती की फोटो", note: "क्लिक करें, भेजें, बस।" },
        { icon: "repeat", title: "\"मासिक BP की दवा\"", note: "दो टैप में रीफ़िल" },
        { icon: "globe", title: "English, ಕನ್ನಡ या हिंदी", note: "अपने smart local chemist से जैसे बात" },
      ],
    },
    catalog: {
      eyebrow: "कैटलॉग और लॉन्च ऑफर",
      offer_kicker: "फ़िक्स्ड डिस्काउंट",
      offer_title: "आपकी सभी खरीद पर Flat 20% डिस्काउंट।",
      offer_body: "अपनी मासिक दवाएँ, vitamins, या जो कुछ भी आप अक्सर केमिस्ट से लाते हैं — पहले ऑर्डर पर 25% बचाइए। कोई code नहीं चाहिए; पहले WhatsApp chat पर अपने आप लग जाएगा।",
      offer_cta: "WhatsApp पर लीजिए",
      catalog_kicker: "हम स्टॉक करते हैं",
      catalog_title: "30,000+ दवाएँ और healthcare प्रोडक्ट्स",
      catalog_body: "रोज़मर्रा की क्रॉनिक बीमारियाँ — Hypertension, Diabetes, Thyroid से लेकर specialty pharma — vaccines, injections और higher antibiotics तक। जो आपके केमिस्ट के पास है, हम आपके दरवाज़े तक पहुँचाएँगे।",
      cats: [
        { title: "Hypertension", note: "BP की दवा, monitors, refill reminders" },
        { title: "Diabetes", note: "Anti-diabetics, glucometers, strips, insulin" },
        { title: "Thyroid", note: "Thyroxine + thyroid-friendly supplements" },
        { title: "Vaccines", note: "वयस्क व बच्चों के लिए, cold-chain delivery" },
        { title: "Injections", note: "Prescription injectables, sterile delivery" },
        { title: "Higher antibiotics", note: "Specialty antibiotics — पर्ची पर, जल्दी" },
      ],
    },
    generics: {
      eyebrow: "स्मार्ट चॉइस",
      title: "वही salt. बेहतर दाम।",
      subtitle: "हर दवा असल में एक chemical composition है, एक brand नहीं। डॉक्टर इलाज composition से करते हैं, पर पर्ची पर वो brand लिखते हैं जो उन्हें promote किया गया होता है। हमारे qualified Pharmacist आपको doctor-recommended branded generic — top Indian pharma से — वही salt, वही strength, 60% तक सस्ता — दे सकते हैं। चुनाव आपका।",
      brand: {
        kicker: "डॉक्टर का बताया brand",
        name: "Telma 40",
        maker: "Glenmark",
        price: "₹156",
        unit: "प्रति strip",
        bullet: "जैसा पर्ची में लिखा है, बिल्कुल वही",
        action: "Brand ही रखिए",
      },
      generic: {
        kicker: "Branded generic",
        name: "Telmisartan 40 mg",
        maker: "Cipla · Sun · Dr. Reddy's",
        price: "₹62",
        unit: "प्रति strip",
        savings: "60% बचत",
        bullets: ["वही salt · वही strength", "Doctor-approved", "Top Indian pharma"],
        action: "बदलिए और बचाइए",
      },
      divider: "या — आपकी मर्ज़ी",
      chips: [
        "सिर्फ़ doctor-recommended generics",
        "100% वही molecule, वही mg",
        "60% तक की बचत",
      ],
      cta: "WhatsApp पर generics के बारे में पूछिए",
    },
    how: {
      eyebrow: "कैसे काम करता है",
      title: "चार स्टेप। एक WhatsApp चैट।",
      steps: [
        { n: "01", title: "अपने तरीक़े से कहिए", body: "WhatsApp पर text, voice note, या फोटो — जैसी भाषा में सुविधाजनक हो।" },
        { n: "02", title: "हम समझकर कन्फर्म करते हैं", body: "हमारे qualified Pharmacists कुछ ही सेकंड में दाम और समय भेजते हैं।" },
        { n: "03", title: "भरोसेमंद स्थानीय स्टोर पैक करता है", body: "आपके पास का Lokam Pharmacy verify करके ऑर्डर तैयार करता है।" },
        { n: "04", title: "60 मिनट में डिलीवरी", body: "घर तक डिलीवरी सिर्फ़ 60 मिनट में। ऑनलाइन या cash, जैसे चाहें।" },
      ],
    },
    coverage: {
      eyebrow: "सेवा क्षेत्र",
      title: "बेंगलुरु के चुनिंदा इलाक़ों में live। जल्द ही पूरे बेंगलुरु में।",
      subtitle: "हम मोहल्ला-दर-मोहल्ला शुरू कर रहे हैं। आपका इलाक़ा नहीं दिख रहा? हमें मैसेज कीजिए — प्राथमिकता मिलेगी।",
      now: "अभी उपलब्ध",
      soon: "जल्द शुरू",
      areas_now: [
        "HSR Layout", "Bellandur", "Sarjapur Road", "Harlur",
        "Choodasandra", "Bommanahalli", "Banashankari", "Nagarbhavi",
        "Jayanagar", "JP Nagar", "Vijayanagar", "Kanakpura Road", "Basavanagudi",
      ],
      areas_soon: [
        "Whitefield", "Indiranagar", "Koramangala", "Hebbal", "Yelahanka", "Marathahalli",
      ],
    },
    trust: {
      eyebrow: "परिवार क्यों भरोसा करते हैं",
      title: "जैसे भारत असल में दवा मँगाता है, उसी हिसाब से बना।",
      points: [
        { title: "आपके इलाक़े की भरोसेमंद स्थानीय फार्मेसी", body: "हर पार्टनर आपके इलाक़े की licensed pharmacy है।" },
        { title: "बेहतर दाम", body: "ज़्यादातर online pharmacy से बेहतर, और monthly orders पर extra discount।" },
        { title: "असली इंसान हमेशा उपलब्ध", body: "जब भी order में दिक़्क़त हो, हमारी टीम तुरंत मदद करती है।" },
        { title: "Refill याद रहते हैं", body: "आपकी monthly दवाएँ हमें याद रहती हैं — एक 'हमेशा वाली' काफ़ी है।" },
      ],
    },
    support: {
      eyebrow: "सहायता",
      title: "किसी इंसान से बात कीजिए। कभी भी।",
      subtitle: "सवाल, refill, refund, या prescription पढ़ने में मदद — जैसे चाहें, हमें बताइए।",
      whatsapp: "WhatsApp पर चैट",
      call: "कॉल कीजिए",
      email: "ईमेल भेजिए",
      hours: "सुबह 7 – रात 11 · रोज़",
    },
    footer: {
      tagline: "भारत का पहला बातचीत वाला healthcare delivery platform। जैसे बोलते हैं, वैसे ऑर्डर कीजिए।",
      links_company: "कंपनी",
      links_legal: "नीतियाँ",
      company: ["प्रेस"],
      legal: [
        { label: "प्राइवेसी पॉलिसी", to: "/privacy" },
        { label: "नियम व शर्तें", to: "/terms" },
        { label: "रद्दीकरण व रिफ़ंड", to: "/refund-policy" },
      ],
      rights: "© 2025 Billion Health Technologies Pvt. Ltd. सर्वाधिकार सुरक्षित।",
    },
    floating: {
      label: "WhatsApp पर ऑर्डर करें",
    },
  },
  kn: {
    code: "kn",
    label: "ಕನ್ನಡ",
    short: "ಕ",
    offer: "ನಿಮ್ಮ ಮೊದಲ ಆರ್ಡರ್ ಮೇಲೆ FLAT 25% OFF",
    hospitals_link: "ಆಸ್ಪತ್ರೆಗಳಿಗಾಗಿ",
    nav: {
      how: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
      coverage: "ಸೇವಾ ಪ್ರದೇಶ",
      support: "ಸಹಾಯ",
      cta: "WhatsApp ನಲ್ಲಿ ಆರ್ಡರ್",
    },
    hero: {
      eyebrow: "ಭಾರತದ ಮೊದಲ ಸಂಭಾಷಣಾ ಫಾರ್ಮಸಿ",
      title_part1: "ನಿಮ್ಮ ಕೆಮಿಸ್ಟ್ ಜೊತೆ ಮಾತಾಡುವಂತೆಯೇ",
      title_highlight: "ಔಷಧಿ ಆರ್ಡರ್ ಮಾಡಿ.",
      subtitle:
        "ಪ್ರಿಸ್ಕ್ರಿಪ್ಷನ್ ಫೋಟೋ ಕಳಿಸಿ. ಅರ್ಧ ಹೆಸರು ಬರೆಯಿರಿ. ಅಥವಾ ಧ್ವನಿಯಲ್ಲಿ 'ನನ್ನ ರೆಗ್ಯುಲರ್ baby drops ಕಳಿಸಿ' ಎನ್ನಿ — 60 ನಿಮಿಷದಲ್ಲಿ ತಲುಪಿಸುತ್ತೇವೆ.",
      cta_primary: "WhatsApp ನಲ್ಲಿ ಶುರು ಮಾಡಿ",
      cta_secondary: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ ನೋಡಿ",
      trust: "ಆಪ್ ಬೇಡ · ಡೆಲಿವರಿಯಲ್ಲಿ ಪಾವತಿ · 60 ನಿಮಿಷ ಎಕ್ಸ್ ಪ್ರೆಸ್ ಡೆಲಿವರಿ",
    },
    chat: {
      bubble1: "ಅಣ್ಣಾ, ತಿಂಗಳ BP ಔಷಧಿ ಕಳಿಸಿ 🙏",
      bubble2: "ಮತ್ತೆ ಈ ಪ್ರಿಸ್ಕ್ರಿಪ್ಷನ್ ನೋಡಿ 📎",
      bubble3: "ಸಿಕ್ತು! Telmisartan 40mg + Metformin 500mg. ₹485, 52 ನಿಮಿಷದಲ್ಲಿ ಬರ್ತಿದೆ — ಕನ್ಫರ್ಮ್?",
      bubble4: "ಹೌದು ಕನ್ಫರ್ಮ್, ಧನ್ಯವಾದ!",
      stamp_left: "ನೀವು · ಈಗ",
      stamp_right: "Lokam · ಸ್ವಯಂ-ಕನ್ಫರ್ಮ್",
      delivery: "ಡೆಲಿವರಿಗೆ ಹೊರಟಿದೆ · 52 ನಿಮಿಷ",
    },
    chaos: {
      title: "ನಿಮ್ಮ ಕೆಮಿಸ್ಟ್ ಗೆ ಹೇಳುವ ರೀತಿಯಲ್ಲೇ —",
      subtitle: "ನಾವೂ ಅರ್ಥ ಮಾಡಿಕೊಳ್ಳುತ್ತೇವೆ. ಮೆನು, ಫಾರ್ಮ್, ಕೋಡ್ ಬೇಡ.",
      items: [
        { icon: "image", title: "ಮಸುಕು ಪ್ರಿಸ್ಕ್ರಿಪ್ಷನ್ ಫೋಟೋ", note: "ಡಾಕ್ಟರ್ ಕೈಬರಹ ಕೂಡ" },
        { icon: "mic", title: "\"ನನ್ನ ರೆಗ್ಯುಲರ್ baby drops ಕಳಿಸಿ\"", note: "ನಿಮ್ಮ ನಿತ್ಯದ್ದು ನೆನಪಿರ್ತದೆ" },
        { icon: "type", title: "ಅರ್ಧ ಹೆಸರು ಸಾಕು", note: "\"ಆ cholesterol ದ್ದು\"" },
        { icon: "camera", title: "ಹಳೇ ಪತ್ರೆಯ ಫೋಟೋ", note: "ಫೋಟೋ ತಗೊಂಡು ಕಳಿಸಿ" },
        { icon: "repeat", title: "\"ಮಾಸಿಕ BP ಔಷಧಿ\"", note: "ಎರಡು ಟ್ಯಾಪ್ ರಿಫಿಲ್" },
        { icon: "globe", title: "English, ಕನ್ನಡ ಅಥವಾ हिंदी", note: "ನಿಮ್ಮ smart local chemist ಜೊತೆ ಮಾತಾಡಿದಂತೆ" },
      ],
    },
    catalog: {
      eyebrow: "ಕ್ಯಾಟಲಾಗ್ ಮತ್ತು ಲಾಂಚ್ ಆಫರ್",
      offer_kicker: "ಫಿಕ್ಸ್ಡ್ ಡಿಸ್ಕೌಂಟ್",
      offer_title: "ನಿಮ್ಮ ಎಲ್ಲಾ ಖರೀದಿಗಳ ಮೇಲೆ Flat 20% ಡಿಸ್ಕೌಂಟ್.",
      offer_body: "ನಿಮ್ಮ ಮಾಸಿಕ ಔಷಧಿ, vitamins, ಅಥವಾ ಕೆಮಿಸ್ಟ್‌ಗೆ ನೀವು ಸಾಮಾನ್ಯವಾಗಿ ಹೋಗುವ ಎಲ್ಲವೂ — ಮೊದಲ ಆರ್ಡರ್‌ನಲ್ಲಿ 25% ಉಳಿಸಿ. ಕೋಡ್ ಬೇಡ; ಮೊದಲ WhatsApp chat ನಲ್ಲೇ apply ಆಗ್ತದೆ.",
      offer_cta: "WhatsApp ನಲ್ಲಿ ಕ್ಲೈಮ್",
      catalog_kicker: "ನಾವು ಸ್ಟಾಕ್ ಮಾಡ್ತೇವೆ",
      catalog_title: "30,000+ ಔಷಧಿ ಮತ್ತು ಆರೋಗ್ಯ ಉತ್ಪನ್ನಗಳು",
      catalog_body: "ಪ್ರತಿದಿನದ ಕ್ರೋನಿಕ್ ಪರಿಸ್ಥಿತಿಗಳಾದ Hypertension, Diabetes, Thyroid ಯಿಂದ ಹಿಡಿದು specialty pharma — vaccines, injections ಮತ್ತು higher antibiotics ವರೆಗೆ. ನಿಮ್ಮ ಕೆಮಿಸ್ಟ್ ಬಳಿ ಇದ್ರೆ, ಅದು ನಿಮ್ಮ ಮನೆ ಬಾಗಿಲಿಗೆ ಬರ್ತದೆ.",
      cats: [
        { title: "Hypertension", note: "BP ಮಾತ್ರೆ, monitors, refill reminders" },
        { title: "Diabetes", note: "Anti-diabetics, glucometers, strips, insulin" },
        { title: "Thyroid", note: "Thyroxine + thyroid-friendly supplements" },
        { title: "Vaccines", note: "ವಯಸ್ಕರಿಗೆ ಮತ್ತು ಮಕ್ಕಳಿಗೆ, cold-chain delivery" },
        { title: "Injections", note: "Prescription injectables, sterile delivery" },
        { title: "Higher antibiotics", note: "Specialty antibiotics — Rx ಮೇಲೆ, ಬೇಗ" },
      ],
    },
    generics: {
      eyebrow: "ಸ್ಮಾರ್ಟ್ ಆಯ್ಕೆ",
      title: "ಅದೇ salt. ಬುದ್ಧಿವಂತ ಬೆಲೆ.",
      subtitle: "ಪ್ರತಿ ಔಷಧಿ ಒಂದು chemical composition, ಒಂದು brand ಅಲ್ಲ. ಡಾಕ್ಟರ್‌ಗಳು composition ಮೂಲಕ ಚಿಕಿತ್ಸೆ ಕೊಡ್ತಾರೆ, ಆದರೆ ಅವರಿಗೆ promote ಆಗಿರುವ brand ಬರೀತಾರೆ. ನಮ್ಮ qualified Pharmacist ನಿಮಗೆ doctor-recommended branded generic ನೀಡಬಹುದು — top Indian pharma ದಿಂದ, ಅದೇ salt, ಅದೇ strength, 60% ಕಡಿಮೆ ಬೆಲೆಗೆ. ಆಯ್ಕೆ ನಿಮ್ಮದು.",
      brand: {
        kicker: "ಡಾಕ್ಟರ್ ಹೇಳಿದ brand",
        name: "Telma 40",
        maker: "Glenmark",
        price: "₹156",
        unit: "ಪ್ರತಿ strip",
        bullet: "ಪ್ರಿಸ್ಕ್ರಿಪ್ಷನ್‌ನಲ್ಲಿ ಇರುವಂತೆ",
        action: "Brand ಇರಲಿ",
      },
      generic: {
        kicker: "Branded generic",
        name: "Telmisartan 40 mg",
        maker: "Cipla · Sun · Dr. Reddy's",
        price: "₹62",
        unit: "ಪ್ರತಿ strip",
        savings: "60% ಉಳಿಸಿ",
        bullets: ["ಅದೇ salt · ಅದೇ strength", "Doctor-approved", "Top Indian pharma"],
        action: "ಬದಲಿಸಿ, ಉಳಿಸಿ",
      },
      divider: "ಅಥವಾ — ನಿಮ್ಮ ಆಯ್ಕೆ",
      chips: [
        "ಕೇವಲ doctor-recommended generics",
        "100% ಅದೇ molecule, ಅದೇ mg",
        "60% ವರೆಗೆ ಉಳಿತಾಯ",
      ],
      cta: "WhatsApp ನಲ್ಲಿ generics ಬಗ್ಗೆ ಕೇಳಿ",
    },
    how: {
      eyebrow: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
      title: "ನಾಲ್ಕು ಹೆಜ್ಜೆ. ಒಂದು WhatsApp ಚಾಟ್.",
      steps: [
        { n: "01", title: "ನಿಮ್ಮ ರೀತಿಯಲ್ಲಿ ಹೇಳಿ", body: "WhatsApp ನಲ್ಲಿ text, voice note, ಅಥವಾ ಫೋಟೋ — ನಿಮ್ಮಿಷ್ಟದ ಭಾಷೆಯಲ್ಲಿ." },
        { n: "02", title: "ನಾವು ಅರ್ಥಮಾಡಿಕೊಂಡು ಕನ್ಫರ್ಮ್ ಮಾಡ್ತೇವೆ", body: "ನಮ್ಮ qualified Pharmacists ಸೆಕೆಂಡಿನಲ್ಲಿ ಬೆಲೆ ಮತ್ತು ಸಮಯ ಕಳಿಸ್ತಾರೆ." },
        { n: "03", title: "ವಿಶ್ವಾಸಾರ್ಹ ಸ್ಥಳೀಯ ಸ್ಟೋರ್ ಪ್ಯಾಕ್ ಮಾಡ್ತದೆ", body: "ನಿಮ್ಮ ಹತ್ತಿರದ Lokam Pharmacy verify ಮಾಡಿ ಆರ್ಡರ್ ಸಿದ್ಧಪಡಿಸ್ತದೆ." },
        { n: "04", title: "60 ನಿಮಿಷದ ಡೆಲಿವರಿ", body: "ಮನೆ ಬಾಗಿಲಿಗೆ 60 ನಿಮಿಷದಲ್ಲಿ. Online ಅಥವಾ cash, ಯಾವುದು ಬೇಕು." },
      ],
    },
    coverage: {
      eyebrow: "ಸೇವಾ ಪ್ರದೇಶ",
      title: "ಬೆಂಗಳೂರಿನ ಆಯ್ದ ಪಿನ್‌ಕೋಡ್‌ಗಳಲ್ಲಿ live. ಶೀಘ್ರದಲ್ಲೇ ಇಡೀ ಬೆಂಗಳೂರಿಗೆ.",
      subtitle: "ಬಡಾವಣೆ-ಬಡಾವಣೆಯಿಂದ ಶುರು ಮಾಡ್ತಾ ಇದ್ದೇವೆ. ನಿಮ್ಮ ಪ್ರದೇಶ ಕಾಣಿಸ್ತಿಲ್ವ? ಸಂದೇಶ ಕಳಿಸಿ — ಆದ್ಯತೆ ಸಿಗ್ತದೆ.",
      now: "ಈಗ ಲಭ್ಯ",
      soon: "ಶೀಘ್ರದಲ್ಲೇ",
      areas_now: [
        "HSR Layout", "Bellandur", "Sarjapur Road", "Harlur",
        "Choodasandra", "Bommanahalli", "Banashankari", "Nagarbhavi",
        "Jayanagar", "JP Nagar", "Vijayanagar", "Kanakpura Road", "Basavanagudi",
      ],
      areas_soon: [
        "Whitefield", "Indiranagar", "Koramangala", "Hebbal", "Yelahanka", "Marathahalli",
      ],
    },
    trust: {
      eyebrow: "ಕುಟುಂಬಗಳು ಯಾಕೆ ನಂಬ್ತಾರೆ",
      title: "ಭಾರತ ನಿಜವಾಗಿ ಔಷಧಿ ಆರ್ಡರ್ ಮಾಡುವ ರೀತಿಗೆ ತಕ್ಕಂತೆ.",
      points: [
        { title: "ನಿಮ್ಮ ಪ್ರದೇಶದ ವಿಶ್ವಾಸಾರ್ಹ ಸ್ಥಳೀಯ ಫಾರ್ಮಸಿಗಳು", body: "ಪ್ರತಿ ಪಾರ್ಟ್‌ನರ್ ನಿಮ್ಮ ಬಡಾವಣೆಯ licensed pharmacy." },
        { title: "ಸ್ಪರ್ಧಾತ್ಮಕ ಬೆಲೆ", body: "ಹೆಚ್ಚಿನ online pharmacy ಗಿಂತ ಉತ್ತಮ; ಮಾಸಿಕ orders ಗೆ extra discount." },
        { title: "ಯಾವಾಗಲೂ ಲಭ್ಯ ಮನುಷ್ಯರು", body: "Order ಸ್ಪಷ್ಟ ಇಲ್ಲದಿದ್ರೆ ನಮ್ಮ ತಂಡ ತಕ್ಷಣ ಸಹಾಯ ಮಾಡ್ತದೆ." },
        { title: "Refills ನೆನಪಿರ್ತದೆ", body: "ನಿಮ್ಮ ಮಾಸಿಕ ಔಷಧಿ ನಮಗೆ ಗೊತ್ತು — 'ಎಂದಿನಂತೆ' ಸಾಕು." },
      ],
    },
    support: {
      eyebrow: "ಸಹಾಯ",
      title: "ಮನುಷ್ಯರ ಜೊತೆ ಮಾತಾಡಿ. ಯಾವಾಗ ಬೇಕಾದ್ರೂ.",
      subtitle: "ಪ್ರಶ್ನೆ, refill, refund, ಅಥವಾ prescription ಓದಲು ಸಹಾಯ — ಯಾವ ರೀತಿ ಬೇಕೋ ಆ ರೀತಿ.",
      whatsapp: "WhatsApp ನಲ್ಲಿ ಚಾಟ್",
      call: "ಕರೆ ಮಾಡಿ",
      email: "ಇಮೇಲ್ ಕಳಿಸಿ",
      hours: "ಬೆಳಿಗ್ಗೆ 7 – ರಾತ್ರಿ 11 · ಪ್ರತಿದಿನ",
    },
    footer: {
      tagline: "ಭಾರತದ ಮೊದಲ ಸಂಭಾಷಣಾ healthcare delivery platform. ಮಾತಾಡುವ ರೀತಿಯಲ್ಲೇ ಆರ್ಡರ್ ಮಾಡಿ.",
      links_company: "ಕಂಪನಿ",
      links_legal: "ನೀತಿಗಳು",
      company: ["ಪತ್ರಿಕೆ"],
      legal: [
        { label: "ಗೌಪ್ಯತಾ ನೀತಿ", to: "/privacy" },
        { label: "ಸೇವಾ ನಿಯಮಗಳು", to: "/terms" },
        { label: "ರದ್ದತಿ ಮತ್ತು ರಿಫಂಡ್", to: "/refund-policy" },
      ],
      rights: "© 2025 Billion Health Technologies Pvt. Ltd. ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    },
    floating: {
      label: "WhatsApp ನಲ್ಲಿ ಆರ್ಡರ್",
    },
  },
};

export const supportedLanguages = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिन्दी", short: "हि" },
  { code: "kn", label: "ಕನ್ನಡ", short: "ಕ" },
];

export const heroImages = {
  pills: "https://customer-assets.emergentagent.com/job_medicine-dial/artifacts/z7c2lpr8_ChatGPT%20Image%20Jun%209%2C%202026%2C%2008_26_50%20PM.png",
  trust: "/lokam-family.png",
  delivery: "/lokam-delivery.png",
};
